//Custom Element Register
if (!customElements.get('rxc-activator')) {
  class RXCActivator extends HTMLElement {
    constructor() {
      super();
      this.singletonCheck();
      this.activatorBtn = null;
      this.isLoading = false;
      this.shopUrl = null;
      this.proxyPath = null;
      this.rxcFrameId = null;
      this.rxcFrameTitle = null;
      this.rxcErrorMsg = null;
      console.log('[Shopify RXCActivator] Init - Mounting');
      this.activatorBtn = this.querySelector("[name='rxc-activator']");
      this.addToBagBtn = document.querySelector(`#ProductSubmitButton-${this.dataset.sectionId}`);
      this.params = new URLSearchParams(window.location.search);
    }

    connectedCallback() {
      document.addEventListener("prescription-lenses-click", () => {
        this.activatorBtn?.click();
      })
      // If variant is not available do nothing
      //   commented to fix issue with CTAs when page is loaded with OOS variant and then user select an available one
      // if(!this.isVariantAvailable()) return;

      this.checkMocoAvailability();

      // Show button when location changed
      subscribe(PUB_SUB_EVENTS.variantChange, () => {
        document.querySelector(".product-form__buttons")?.classList.add("tw-hidden");
        // If variant is not available do nothing
        if(!this.isVariantAvailable()) {
          document.querySelector(".product-form__buttons")?.classList.remove("tw-hidden");
          return;
        }
        // if (this.activatorBtn) this.activatorBtn.style.display = "block";
        console.log("variant change - checking MoCo availability");
        this.checkMocoAvailability();
        document.querySelector(".product-form__buttons")?.classList.remove("tw-hidden");
      });
      // Hide button when selected new face size
      subscribe(PUB_SUB_EVENTS.faceSizeSelection, () => {
        document.querySelector(".product-form__buttons")?.classList.add("tw-hidden");
        if (this.activatorBtn) this.activatorBtn.style.display = "none";
        //this.checkMocoAvailability();
      });
    } 
    isVariantAvailable(){
      //check if data-btn-status exist in the DOM
      if(this.dataset.preorder == "true") return false;
      if(!document.querySelector("[data-btn-status]")) return true;
      return document.querySelector("[data-btn-status='product_ok']") ? true : false;
    }

    checkMocoAvailability() { 
      const market = this.activatorBtn.getAttribute('data-market');
  
      // Estrai e normalizza l'handle
      const urlSlices = window.location.pathname.split('/');
      const productHandle = urlSlices[urlSlices?.length - 1];
      const [modelCode, colorCode] = productHandle.split('-');
      const adaptedModelCode = modelCode.toUpperCase();
      const adaptedMoCo = modelCode.toUpperCase() + '__' + colorCode.toUpperCase();

      // Local variables
      const BASE_URL = 'https://assets.oliverpeoples.com/extra/image/rxcbe';
      const ENVIRONMENT = this.dataset.env;
      const BRAND_CODE = 'OP';

      this.fetchAvailability(
        BASE_URL,
        ENVIRONMENT,
        BRAND_CODE,
        market,
        adaptedModelCode,
        adaptedMoCo
      );
    }

    fetchAvailability(BASE_URL, ENVIRONMENT, BRAND_CODE, market, adaptedModelCode, adaptedMoCo) {
      let isMocoAvailable = false;
      let isModelAvailable = false;

      fetch(`${BASE_URL}/${ENVIRONMENT}/availability/${BRAND_CODE}/${market}/availability_${adaptedModelCode}.json`)
        .then(res => res.json())
        .then(res => {
          isMocoAvailable = res[adaptedMoCo]?.availability === true ? true : false;
          isModelAvailable = Object.keys(res).some(key => key.startsWith(adaptedModelCode + '__'));

          if (isMocoAvailable && isModelAvailable) {
            console.log("RXC - MoCo is available");
            this.displayPrescriptionCta(true);
            const isFullCtasMarket = this.dataset.fullCtasMarket === 'true';
            if(this.dataset.productType == "Optical" && !isFullCtasMarket) {
              this.removeExpressCheckout();
              if (this.addToBagBtn) this.addToBagBtn.style.display = 'none';
              this.activatorBtn.classList.remove("tw-mt-op-spacings-base", "tw-op-btn-outline");
              this.activatorBtn.classList.add("tw-op-btn-filled");
              this.activatorBtn.classList.replace("data-[loading]:tw-op-btn-outline-loading", "data-[loading]:tw-op-btn-filled-loading");
              this.changeCopy(this.dataset.secondaryCopy);
              publish("select-lenses", {source: "rxc-activator", copy: this.dataset.secondaryCopy});
            } else {
              this.activatorBtn.classList.add("tw-mt-op-spacings-base", "tw-op-btn-outline");
              this.activatorBtn.classList.remove("tw-op-btn-filled");
              this.changeCopy(this.dataset.primaryCopy);
            }
            this.activatorBtn.style.display = 'flex';
            this.activatorBtn.setAttribute('data-is-available', 'true');
          } else this.displayPrescriptionCta(false);

          if (isMocoAvailable) {
            this.isLoading = false;
            this.shopUrl = window.location.host + window.Shopify.routes.root;
            this.proxyPath = market === 'US' ? 'rxc-us' : 'rxc';
            this.rxcFrameId = this.dataset.rxcFrameId || 'rxc-iframe';
            this.rxcFrameTitle = this.dataset.rxcFrameTitle || 'RXC - Lens Configurator';
            this.rxcErrorMsg = this.dataset.rxcErrorMsg || 'Error RXC Loading - Try later';

            window.addEventListener('message', this.window_messageHandler);
            this.activatorBtn?.addEventListener('click', this.activator_clickHandler);
            if (this.params.get('rxc-wishlist') === 'true') {
              this.activator_clickHandler(new Event('auto'));
            }

            const searchParams = new URLSearchParams(window.location.search);

            let rxcUrlContext = {
              isEditLenses: searchParams.get('isEditLenses') === 'true',
              isAddLenses: searchParams.get('isAddLenses') === 'true',
              frameUniqueId: searchParams.get('frameUniqueId'),
              lensUniqueId: searchParams.get('lensUniqueId'),
              orderItemId: searchParams.get('orderItemId'),
              frameSize: searchParams.get('size'),
            };

            const isEditingContext =
              rxcUrlContext.isEditLenses && rxcUrlContext.frameUniqueId && rxcUrlContext.lensUniqueId && rxcUrlContext.orderItemId;
            const isAddContext = rxcUrlContext.isAddLenses && rxcUrlContext.frameUniqueId;

            if (isEditingContext || isAddContext) {
              this.setLoading(true);
              this.showFrame(rxcUrlContext);
            }
          }
        })
        .catch(error => {
          this.displayPrescriptionCta(false);
          this.activatorBtn.style.display = 'none';
          if (this.addToBagBtn) this.addToBagBtn.style.display = 'block';
          this.activatorBtn.setAttribute('data-is-available', 'false');
        });
    }

    changeCopy(copy) {
      const activatorSpan = this.activatorBtn.querySelector("#activator-span");
      if (activatorSpan) activatorSpan.innerHTML = copy;
    }

    removeExpressCheckout() {
      const expressCheckout = document.querySelector(`.shopify-payment-button`);
      if (expressCheckout) expressCheckout.style.display = "none";
    }

    displayPrescriptionCta(display) {
      document.querySelectorAll(".prescription-cta-link").forEach((cta) => cta.style.display = display ? "" : "none");
    }

    disconnectedCallback() {
      // console.log('[Shopify RXCActivator] Unmounting');
      window.removeEventListener('message', this.window_messageHandler);
      this.activatorBtn?.removeEventListener('click', this.activator_clickHandler);
    }

    singletonCheck() {
      if (document.getElementsByTagName('rxc-activator').length > 1) {
        console.error('Multiple instances of <rxc-activator> detected. Only one instance is allowed.');
        return false;
      }
      return true;
    }
  
    setLoading(isLoading) {
      if (this.activatorBtn) {
        this.activatorBtn.toggleAttribute('data-loading', isLoading);
        this.activatorBtn.ariaDisabled = isLoading;
      }
  
      this.isLoading = isLoading;
    }
  
    activator_clickHandler = evt => {
      evt.preventDefault();
  
      if (!this.shopUrl) {
        console.error('Shop URL not found');
        return;
      }
  
      if (!this.isLoading) {
        this.setLoading(true);
        this.showFrame();
      }
    }

    redirectToCart() {
      const cartUrl = window.routes.cart_url || `${window.Shopify?.routes?.root || "/"}cart`;
      const separator = cartUrl.includes('?') ? '&' : '?';
      window.location.href = `${cartUrl}?disable_event=true`;
    }
  
    showFrame(rxcUrlContext = {}) {
      const urlParams = new URLSearchParams(window.location.search);
  
      const variantId = urlParams.get('variant') || this.activatorBtn.getAttribute('data-variant-id');
      const country = this.activatorBtn.getAttribute('data-market');
      const market = this.activatorBtn.getAttribute('data-market-id');
      const language = this.activatorBtn.getAttribute('data-language');
      const currency = this.activatorBtn.getAttribute('data-currency');
  
      const iframeUrl = new URL(`${window.location.protocol}//${this.shopUrl}apps/${this.proxyPath}/prescription/index`);
      const iframe = document.getElementById(this.rxcFrameId) || document.createElement('iframe');
  
      if (rxcUrlContext && Object.keys(rxcUrlContext)?.length) {
        const isEditingContext =
          rxcUrlContext.isEditLenses && rxcUrlContext.frameUniqueId && rxcUrlContext.lensUniqueId && rxcUrlContext.orderItemId;
        const isAddContext = rxcUrlContext.isAddLenses && rxcUrlContext.frameUniqueId && rxcUrlContext.orderItemId;
  
        if (isAddContext) {
          iframeUrl.searchParams.set('isAddLenses', 'true');
          iframeUrl.searchParams.set('frameUniqueId', rxcUrlContext.frameUniqueId);
          iframeUrl.searchParams.set('orderItemId', rxcUrlContext.orderItemId);
          iframeUrl.searchParams.set('rxc_cart_redirect_enabled', 'true');
        }
  
        if (isEditingContext) {
          iframeUrl.searchParams.set('isEditLenses', 'true');
          iframeUrl.searchParams.set('frameUniqueId', rxcUrlContext.frameUniqueId);
          iframeUrl.searchParams.set('lensUniqueId', rxcUrlContext.lensUniqueId);
          iframeUrl.searchParams.set('orderItemId', rxcUrlContext.orderItemId);
          iframeUrl.searchParams.set('rxc_cart_redirect_enabled', 'true');
        }
      }
  
      iframeUrl.searchParams.set('rxc_cart_redirect_enabled', 'false');
      iframeUrl.searchParams.set('variantId', variantId);
      iframeUrl.searchParams.set('market', country);
      iframeUrl.searchParams.set('market_id', market);
      iframeUrl.searchParams.set('language', language);
      iframeUrl.searchParams.set('currency', currency);
  
      iframe.id = this.rxcFrameId;
      iframe.title = this.rxcFrameTitle;
      iframe.tabIndex = -1;
      iframe.src = iframeUrl.toString();
  
      iframe.onerror = () => {
        console.error('RXC App Embed Error');
        this.onRXCError();
      };
  
      iframe.toggleAttribute('data-loading', true);
      document.body.appendChild(iframe);
    }
  
    onFrameLoaded() {
      const rxcAppEmbed = document.getElementById(this.rxcFrameId);
      this.setLoading(false);
      publish("frame-loaded", {});
  
      if (!rxcAppEmbed) {
        console.error('RXC App Embed not found');
        return;
      }
  
      rxcAppEmbed.toggleAttribute('data-loading', false);
      rxcAppEmbed.toggleAttribute('data-ready', true);
    }
  
    onRXCError() {
      let messageTemplate = this.querySelector('p[data-rxc-error]') || document.createElement('p');
      messageTemplate.setAttribute('data-rxc-error', true);
      messageTemplate.textContent = this.rxcErrorMsg;
      this.activatorBtn.insertAdjacentElement('afterend', messageTemplate);
      this.setLoading(false);
    }

    onRXCUpdatedCart(payload) {
      if (typeof window.tealium_data2track?.push === "function" && payload?.products) {
        for (let k in payload.products) {
          if ("Status" in payload.products[k]) continue;
          payload.products[k].Status = payload.products[k].status || "Available";
          delete payload.products[k].status;
        }
          
        window.tealium_data2track.push({
          id: "Event",
          Products: payload.products
        }); 
        this.redirectToCart();
      }
    }
  
    window_messageHandler = event => {
      const rxcAppData = event?.data?.rxcApp;
  
      if (!rxcAppData) return;
  
      switch (rxcAppData.type) {
        case 'RXC_IS_ON_ERROR':
          console.log('RXC_IS_ON_ERROR RECEIVED:', event.data);
          this.onRXCError();
          break;
        case 'RXC_LOADED':
          console.log('[Shopify RXCActivator] Message from RXC APP:', event.data);
          this.onFrameLoaded();
          break;
        case 'RXC_UPDATED_CART':
          this.onRXCUpdatedCart(rxcAppData.payload);
          break;
      }
    };
  }

  customElements.define('rxc-activator', RXCActivator);
}
